import Vue from 'vue'
import {
  Button,
  Layout,
  Menu,
  Icon,
  Avatar,
  FormModel,
  Input,
  Space,
  Dropdown,
  Row,
  Col,
  Card,
  Table,
  ConfigProvider,
  Checkbox,
  Modal,
  Descriptions,
  AutoComplete,
  Drawer,
  Select,
  DatePicker,
  TimePicker,
  Divider,
  Progress,
  Collapse,
  Popover,
  Popconfirm,
  InputNumber,
  Tree,
  List,
  Pagination,
  Upload,
  Spin,
  Switch,
  Radio,
  Tooltip,
  TreeSelect,
  Tabs,
  Empty
} from 'ant-design-vue'

Vue.prototype.$confirm = Modal.confirm

Vue.use(Button)
Vue.use(Empty)
Vue.use(Tabs)
Vue.use(TreeSelect)
Vue.use(Tooltip)
Vue.use(Layout)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(Avatar)
Vue.use(FormModel)
Vue.use(Input)
Vue.use(Space)
Vue.use(Dropdown)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Table)
Vue.use(ConfigProvider)
Vue.use(Checkbox)
Vue.use(Modal)
Vue.use(Descriptions)
Vue.use(AutoComplete)
Vue.use(Drawer)
Vue.use(Select)
Vue.use(DatePicker)
Vue.use(Divider)
Vue.use(Progress)
Vue.use(Select)
Vue.use(Collapse)
Vue.use(Popover)
Vue.use(Popconfirm)
Vue.use(InputNumber)
Vue.use(Tree)
Vue.use(List)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Spin)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(TimePicker)
